// extracted by mini-css-extract-plugin
export default {"spinnerWrapper":"t1zuI8","hideModal":"ri9WIl"};